import { useQuery } from '@apollo/client';
import { QueryHookOptions } from '@apollo/client/react/types/types';
import { Store } from 'app-types/core';

import { CurrentStoreQuery } from '../../../gql/core/queries';

export function useStoreSettings(options?: QueryHookOptions) {
  const data = useQuery<{ Store_current: Store }>(CurrentStoreQuery, {
    ...options,
    context: { ...options?.context, clientName: 'core' },
  });

  return { ...data, data: data.data?.Store_current };
}
